import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import {
  Box,
  Container,
  alpha,
  Hidden,
  IconButton,
  Typography,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import HeaderPanel from "./Sections/HeaderPanel";
import { connectUserStore } from "../../hoc/connectStore/connectUserStore";
import MenuDesktop from "./MenuDesktop/MenuDesktop";
import HeaderButton from "./Sections/HeaderButton";
import MenuIcon from "@material-ui/icons/Menu";
import MenuDrawer from "./MenuMobile/MenuDrawer";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useQuery } from '@apollo/client';
import { QUERY_PROFILE } from "../../service/ApolloClient/ApolloQueries";
import GlobalSearch from "./GlobalSearch";

const useStyles = makeStyles((theme) => ({
  Appbar: {
    borderBottom: "1px solid #dddddd",
    boxShadow: "0 3px 2px -2px rgba(200,200,200,0.2)",
    transform: "unset !important",
    backgroundColor: "#000000 !important",
  },
  logo: {
    height: "60px",
    marginLeft: "10px",
    [theme.breakpoints.down("md")]: {
      height: "40px",
    },
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "block",
    [theme.breakpoints.up("sm")]: {
      display: "block",
      width: "100px",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "100%",
    },
    flexGrow: 1,
    border: "1px solid #dddddd",
  },
  searchIcon: {
    width: theme.spacing(7),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    flexGrow: 1,
    width: "100%",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "100%",
    },
    flexGrow: 1,
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  notifTitle: {
    paddingTop: 5,
  },
  homeTitle: {
    paddingTop: 5,
  },

  headerIcon: {
    padding: 2,
  },
  buttonAdd: {
    width: 100,
    [theme.breakpoints.down("md")]: {
      width: 10,
    },
    marginTop: 13,
  },
  noPadding: {
    paddingLeft: "0px !important",
    paddingRight: "0px !important",
  },
  menutop: {
    color: "white",
  },
}));

const Header = (props) => {
  const { data, loading, error } = useQuery(QUERY_PROFILE, {});

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));
  const matchesSm = useMediaQuery(theme.breakpoints.down("xs"));

  let classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <MenuDesktop
      anchorEl={anchorEl}
      menuId={menuId}
      isMenuOpen={isMenuOpen}
      handleMenuClose={handleMenuClose}
      profile={!loading ? (data ? data.profile : null) : null}
      loading={loading}
    />
  );

  const mobileMenuId = "primary-search-account-menu-mobile";

  const [state, setState] = React.useState({
    right: false,
  });

  const toggleDrawer = (side, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [side]: open });
  };


  return (
    <div className={classes.grow}>
      <AppBar color={"inherit"} position="static" className={classes.Appbar}>
        {/*<HeaderTopNotification/>*/}
        <Container className={classes.noPadding}>
          <Toolbar className={matchesSm ? classes.noPadding : ""}>
            <Wrapper>
              <Hidden only={["md", "xl", "lg"]}>
                <IconButton onClick={toggleDrawer("left", true)}>
                  <MenuIcon style={{ color: "white" }} />
                </IconButton>
                <Typography style={{ color: "white" }}>
                  سیستم مدیریت چک
                </Typography>
                <MenuDrawer state={state} toggleDrawer={toggleDrawer} />
              </Hidden>

              <Hidden only={["sm", "xs"]}>
                <HeaderButton classes={classes} />
                <Box className={classes.grow}>
                  <GlobalSearch />
                </Box>
              </Hidden>

              <Box
                display={"flex"}
                sx={{ float: "left", color: "#000000", textAlign: "left" }}
                flexGrow={1}
                justifyContent={"flex-end"}
              >
                <HeaderPanel
                  mobileMenuId={mobileMenuId}
                  menuId={menuId}
                  handleProfileMenuOpen={handleProfileMenuOpen}
                  classes={classes}
                  matches={matches}
                  profile={!loading ? (data ? data.profile : null) : null}
                  loading={loading}
                />
              </Box>
            </Wrapper>
          </Toolbar>
        </Container>
      </AppBar>
      {renderMenu}
    </div>
  );
};

export default connectUserStore(Header);
